import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {
    WfProcessStepActivityMainProviderInterface
} from "../../../../feature-core/wf/component/protected-components/process-activity/wf-process-step-activity-main-provider.interface";
import {
    WfProcessTypeStepActivityDto
} from "../../../../feature-core/wf/model/dto/entity/wf-process-type-step-activity.dto";
import {
    WfProcessStepActivityBaseComponent
} from "../../../../feature-core/wf/component/protected-components/process-activity/wf-process-step-activity-base/wf-process-step-activity-base.component";
import {
    CrCustomerCommentWfProcessStepActivityComponent
} from "../../component/protected-components/wf/cr-customer-comment-wf-process-step-activity/cr-customer-comment-wf-process-step-activity.component";
import {
    MvsApiCrudServiceCommentsInterface
} from "../../../../core/shared/service/api/mvs-api-crud-service-comments.interface";

@Injectable({
  providedIn: 'root'
})
export class CustomerCommentService extends MvsCrudService implements MvsApiCrudServiceCommentsInterface, WfProcessStepActivityMainProviderInterface{

  constructor(protected http: HttpClient) {
    super(http, MvsCrudService.baseUrl + '/cr/customerComments');
  }

  /**
   * Return attribute used to store the comment.
   */
  getCommentAttribute(): string {
    return "comment";
  }

  /**
   * Return whether comments support pinning.
   */
  hasCommentPinOption(): boolean {
    return true;
  }

  /**
   * Return linked attribute (required to resolve 1:N relationships).
   * @param objectType
   */
  getLinkedAttribute(objectType: string): string {

    if (objectType === "cr.Customer") {
      return "customer";
    } else {
      return super.getLinkedAttribute(objectType);
    }
  }

  getActivityMainComponent(activityType: WfProcessTypeStepActivityDto): typeof WfProcessStepActivityBaseComponent | null {
    return CrCustomerCommentWfProcessStepActivityComponent;
  }

}
